module.exports = __webpack_public_path__ + "img/interview-logo.5fb1ea53.png";